export const MENU_MOBILE_BREAK_POINT = 1305;

export default MENU_MOBILE_BREAK_POINT;
